export default __webpack_public_path__ + "static/media/report-banner.d06fae7f.webp";